import React from 'react';

const FilloutStructuredData = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "Fillout Expert Services",
    "description": "Professional Fillout form development services with payment processing, team collaboration, and white-label solutions.",
    "provider": {
      "@type": "Person",
      "name": "Daniel Sikmo",
      "jobTitle": "Fillout Expert & Form Developer"
    },
    "serviceType": "Fillout Form Development",
    "areaServed": "Worldwide",
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Fillout Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Custom Form Development",
            "description": "Advanced Fillout forms with conditional logic and calculations"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Payment Integration",
            "description": "Stripe and PayPal payment processing in forms"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Team Collaboration Setup",
            "description": "Multi-user workspaces with role-based permissions"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "White-label Solutions",
            "description": "Fully branded form experiences with custom domains"
          }
        }
      ]
    }
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
    />
  );
};

export default FilloutStructuredData;